"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_components_1 = require("@apollo/react-components");
const reactstrap_1 = require("reactstrap");
const graphql_1 = require("../../graphql");
const AjaxButton_1 = require("./AjaxButton");
const BottomToolbar_1 = require("./BottomToolbar");
const react_2 = require("@osmosys/react");
// interface ILocalFile {
//   name: string;
//   lastModified: number;
//   lastModifiedDate: Date;
// }
class FileUploader extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            filename: null,
            progress: null,
            successBuffer: false,
        };
        this.inputRef = react_1.default.createRef();
    }
    render() {
        return (react_1.default.createElement(react_components_1.Mutation, { mutation: graphql_1.uploadFile, onCompleted: data => {
                const hostedFile = data.uploadFile;
                this.setState({
                    filename: null,
                    progress: null,
                    successBuffer: true,
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            successBuffer: false,
                        });
                    }, 6 * 1000);
                    if (this.props.onUpload) {
                        this.props.onUpload(hostedFile);
                    }
                    if (this.inputRef) {
                        this.inputRef.current.value = '';
                    }
                });
            }, context: {
                fetchOptions: {
                    onUploadProgress: (progress) => {
                        this.setState({ progress });
                    },
                },
            } }, (mutate, result) => {
            const onChange = (e) => {
                // e.preventDefault();
                if (this.inputRef &&
                    this.inputRef.current &&
                    this.inputRef.current.files &&
                    this.inputRef.current.files[0] &&
                    this.inputRef.current.files[0].name) {
                    this.setState({
                        filename: this.inputRef.current.files[0].name,
                        progress: 0,
                    }, () => {
                        mutate({
                            variables: {
                                file: this.inputRef.current.files[0],
                                public: this.props.public !== false,
                            },
                        });
                        const oldOnChange = this.props.onChange;
                        if (oldOnChange) {
                            oldOnChange(e);
                        }
                    });
                }
            };
            const customInputProps = !this.props.children
                ? {}
                : Object.assign(Object.assign({}, this.props), { children: undefined });
            const open = () => {
                this.inputRef.current.click();
            };
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(reactstrap_1.Label, { className: "mb-0" },
                    react_1.default.createElement("input", { type: "file", onChange: onChange, accept: this.props.accept, ref: this.inputRef, style: {
                            position: 'fixed',
                            top: '-100em',
                        } }),
                    this.props.ajaxButton ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(AjaxButton_1.AjaxButton, Object.assign({ label: "Upload", loading: result.loading, error: result.error, success: !!result.data }, this.props, { onClick: open, type: "button" })))) : (react_1.default.createElement(react_1.default.Fragment, null,
                        !this.props.children && (react_1.default.createElement(reactstrap_1.CustomInput, Object.assign({ type: "file" }, customInputProps, { onChange: e => onChange(e) }))),
                        this.props.children &&
                            this.props.children(open, result, this.state.successBuffer)))),
                !isNaN(this.state.progress) &&
                    (result.loading || this.state.successBuffer) && (react_1.default.createElement(react_2.Portal, { elementID: "footer-portal" },
                    react_1.default.createElement(BottomToolbar_1.BottomToolbar, { className: classnames_1.default('text-center text-white p-2', {}) },
                        react_1.default.createElement("p", { className: "lead my-2" }, this.state.successBuffer ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCheckCircle, className: "mr-2" }),
                            react_1.default.createElement("a", { className: "text-white", href: result.data &&
                                    result.data.uploadFile &&
                                    result.data.uploadFile.url }, "Uploaded"))) : this.state.progress !== 100 ? (`Uploaded ${this.state.progress.toFixed(2)}% of ${this.state.filename}`) : (`Processing ${this.state.filename}`)),
                        react_1.default.createElement(reactstrap_1.Collapse, { isOpen: result.loading, className: "pt-2" },
                            react_1.default.createElement(reactstrap_1.Progress, { color: "primary-dark", striped: true, animated: true, value: this.state.progress })))))));
        }));
    }
}
exports.FileUploader = FileUploader;
//# sourceMappingURL=FileUploader.js.map